module.exports = __webpack_public_path__ + "img/71.676dc362.jpg";